import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	CreateDiscountDTO,
	DiscountApplicationResultDTO,
	DiscountFiltersDTO,
	DiscountListResponseDTO,
	DiscountResponseDTO,
	UpdateDiscountDTO,
} from '@libs/dtos/discount/discount.dto';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class DiscountService {
	private readonly baseUrl = `${environment.pathBackend}/discounts`;

	constructor(private http: HttpClient) {}

	getDiscounts(params?: Partial<DiscountFiltersDTO>): Observable<DiscountListResponseDTO> {
		return this.http.get<DiscountListResponseDTO>(this.baseUrl, { params });
	}

	getDiscountById(id: string): Observable<DiscountResponseDTO> {
		return this.http.get<DiscountResponseDTO>(`${this.baseUrl}/${id}`);
	}

	createDiscount(data: CreateDiscountDTO): Observable<DiscountResponseDTO> {
		return this.http.post<DiscountResponseDTO>(this.baseUrl, data);
	}

	updateDiscount(id: string, data: UpdateDiscountDTO): Observable<DiscountResponseDTO> {
		return this.http.put<DiscountResponseDTO>(`${this.baseUrl}/${id}`, data);
	}

	deleteDiscount(id: string): Observable<void> {
		return this.http.delete<void>(`${this.baseUrl}/${id}`);
	}

	/** Deletes several discounts in one request */
	bulkDeleteDiscounts(ids: number[]): Observable<{ affected: number }> {
		return this.http.post<{ affected: number }>(`${this.baseUrl}/bulk-delete`, { ids });
	}

	previewDiscount(basePrice: number, code?: string): Observable<DiscountApplicationResultDTO> {
		const params: { basePrice: string; code?: string } = { basePrice: basePrice.toString() };
		if (code) params.code = code;
		return this.http.get<DiscountApplicationResultDTO>(`${this.baseUrl}/preview`, { params });
	}
}
